import { getRandomInt } from '@ringcentral/rwc-utils/src/misc';
import { uuidV4 } from '@ringcentral/rwc-utils/src/deps-free/uuidV4';

import i18n from 'i18next';
import { makeOverridableFunction } from '@ringcentral/rwc-utils/src/override-api';
import { BEACON_LEAVE_TO_WEBINAR } from '@ringcentral/rwc-bridge';

const PASSWORD_ALPHABET_NUM = '123456789';
const PASSWORD_ALPHABET_CHAR = 'abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ';
const PASSWORD_DEFAULT_LENGTH = 10;

export const parseQueryString = queryString => Object.fromEntries(new URLSearchParams(queryString));

export const crc1 = str => {
    str = String(str);
    let accum = 0;

    for (let index = 0; index < str.length; index++) {
        const byte = str.charCodeAt(index);
        accum += byte;
    }

    return accum % 256;
};

export const handleJSONResponse = response => {
    if (response.ok) {
        return response.json();
    } else {
        return Promise.reject(response.status);
    }
};

/** @deprecated Use uuidV4 from rwc-utils deps-free/uuidV4 */
export const uuidv4 = uuidV4;
export const generateMeetingPassword = (length = PASSWORD_DEFAULT_LENGTH) => {
    const passwordAlphabet = [...PASSWORD_ALPHABET_NUM, ...PASSWORD_ALPHABET_CHAR];

    const randomValues = Array(length)
        .fill(1)
        .map(() => passwordAlphabet[getRandomInt(passwordAlphabet.length)]);

    const hasDigit = randomValues.some(el => !isNaN(el));

    if (!hasDigit) {
        //If array with random values has no at least one digit - should add one in random place
        randomValues.splice(
            getRandomInt(randomValues.length),
            1,
            PASSWORD_ALPHABET_NUM[getRandomInt(PASSWORD_ALPHABET_NUM.length)]
        );
    }

    return randomValues.join('');
};

export const sendBeacon = url => {
    navigator.sendBeacon(url);
};

export const perKeySingleton = constr => {
    var map = {};

    return (type, ...args) => {
        if (!map[type]) {
            map[type] = new constr(...args);
        }

        return map[type];
    };
};

export const tripleMerge = (ours, theirs, resolved) => {
    var res = null;

    if (ours) {
        if (ours !== resolved) {
            res = ours;
        }
    } else if (theirs !== resolved) {
        res = theirs;
    }

    return res;
};

/**
 * Uses the first element of every pair of @pairsArray as a key
 * and second as a corresponding value of resulting object
 * @param {Array<Array<String|Boolean>>} pairsArray
 * @example pairsToDict([[first, second],[third, fourth]]) ->
 * {
 *  first: second,
 *  third: fourth
 * }
 * @param {*} reverse
 * @returns {Object}
 */
export const pairsToDict = (pairsArray, reverse = false) => {
    if (reverse) {
        pairsArray = pairsArray.map(item => item.reverse());
    }

    return Object.fromEntries(pairsArray);
};

/**
 * @deprecated Use keys from packages/rwc-utils/src/misc.ts
 */
export const keyCodes = {
    SPACE: 32,
    ENTER: 13,
    ESC: 27,
    DOWN_ARROW: 40,
    UP_ARROW: 38,
    SHIFT: 16,
    TAB: 9,
};

/**
 * @deprecated Use keys from packages/rwc-utils/src/misc.ts
 */
export const keys = {
    TAB: 'Tab',
    ESC: 'Escape',
    RIGHT_ARROW: 'ArrowRight',
    LEFT_ARROW: 'ArrowLeft',
    ENTER: 'Enter',
    UP_ARROW: 'ArrowUp',
    DOWN_ARROW: 'ArrowDown',
    SPACE: 'Space',
};

// i18n has its custom encode function which works on passed options
// and can't be reversed with standard `unescape` or `encodeURIComponent`
// so we have to manually decode at least apostrophes (some names have them).
// We also can remove encoding at all in certain i18n calls, but it is dangerous.

// eslint-disable-next-line quotes
export const i18nWithApostrophes = (key, options) => i18n.t(key, options).replace(/&#39;/g, "'");

export const callLeaveViaBeacon = makeOverridableFunction(() => {}, BEACON_LEAVE_TO_WEBINAR);

export const clearNilValues = obj =>
    Object.fromEntries(
        Object.entries(obj).filter(([, value]) => value !== null && value !== undefined)
    );
